import { Component, OnInit, ChangeDetectorRef, ViewChild, HostListener } from '@angular/core';
import * as _ from 'lodash';
import * as moment from 'moment';

import { InspectionService, AuthService, LanguageService, ApplicationService } from '../shared/services/index';
import { PeopleService } from '../shared/services/people.service';
import { DashboardStatistic, HomeButton, Inspection, InspectionStatistic, Person } from '../shared/models/index';
import { ModalComponent } from '../modal/modal.component';
import { ApplicationType, SelectorComponent } from '../utils/index';
import { BaseComponent } from '../shared/components/base.component';
import { Router } from '@angular/router';
import { InformationComponent } from '../modal/information.component';
import { ConfirmComponent } from '../modal/confirm.component';
import { NewVersionModalComponent } from '../shared/components';
import { Observable } from 'rxjs';

@Component({
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent extends BaseComponent implements OnInit {
  currentPerson: Person;
  upcomingInspection: InspectionStatistic;
  languages: any[];
  currentLanguage: string;
  dashboardStatistic: DashboardStatistic;
  offlineInspection: Inspection;
  buttons$: Observable<HomeButton[]>;
  private applicationTypes: any[];
  private currentPersonApplicationTypes: any[];
  private confirmLogout = false;
  @ViewChild('languagesModal', { static: true }) languageModal: ModalComponent;
  @ViewChild('appModal', { static: true }) appModal: ModalComponent;
  @ViewChild('inspectionOfflineReminder', { static: true }) inspectionOfflineReminder: InformationComponent;
  @ViewChild('syncronizationReminder', { static: true }) syncronizationReminder: ConfirmComponent;
  @ViewChild('versionModal', { static: true }) versionModal: ModalComponent;
  @HostListener('window:beforeunload', ['$event']) beforeunload($event) {
    if (this.offlineInspection && this.offlineInspection.updatedOffline && !this.confirmLogout) {
      const message = `You have a locally registered inspection, don't forget to synchronize it sometimes.`;
      $event.preventDefault();
      $event.returnValue = message;
    }
  }

  constructor(
    private inspectionService: InspectionService,
    private peopleService: PeopleService,
    private authService: AuthService,
    private changeDetectorRef: ChangeDetectorRef,
    private language: LanguageService,
    private applicationService: ApplicationService,
    private router: Router
  ) {
    super();
  }

  openLogout() {
    if (this.offlineInspection && this.offlineInspection.updatedOffline) {
      this.syncronizationReminder.warningIcon = true;
      this.syncronizationReminder.open();
    } else {
      this.logout();
    }
  }

  logout() {
    this.confirmLogout = true;
    this.authService.logout().subscribe(() => {
      this.peopleService.logout();
    });
  }

  public initDate() {
    this.applicationService.getApplicationTypes().subscribe((types) => {
      this.applicationTypes = types.map((t) => Object.assign({}, t));
      this.applicationTypes.forEach((app) => {
        this.language.getValueByKey(app.Label).subscribe((label) => {
          app.Label = label;
        });
      });
    });

    this.currentLanguage = this.language.get();
    this.peopleService.getCurrent().subscribe((data) => {
      this.currentPerson = data;
      if (!this.currentLanguage) {
        this.currentLanguage = data.language ? data.language : 'en';
      }
    });

    this.language.getLanguages().subscribe((data) => {
      this.languages = data;
    });

    this.inspectionService.getInspections().subscribe((el) => {
      const inspections = _.orderBy(el, ['startDate']);
      const forbidenStatuses = [250, 300, 350];
      if (this.offlineInspectionId) {
        this.offlineInspection = el.find((inspection) => inspection.id === this.offlineInspectionId);
        if (this.offlineInspection && this.isOptimization) {
          let machines =
            this.offlineInspection.data != null && this.offlineInspection.data.machine != null
              ? this.offlineInspection.data.machine
              : null;
          if (machines) {
            if (!(machines instanceof Array)) {
              machines = '';
            }
            this.offlineInspection.data.machine.name = _.join(
              machines.map((m) => m.name),
              ','
            );
          }
        }
      }
      this.changeDetectorRef.detectChanges();
    });
    this.inspectionService.getinspectionStatisticByPerson().subscribe((res) => {
      this.dashboardStatistic = res;
      if (res.inspectionsUpcoming.length) {
        this.upcomingInspection = res.inspectionsUpcoming.find((i) => i.technicianId === this.currentUserId);
        if (this.upcomingInspection) {
          this.upcomingInspection.days = moment(this.upcomingInspection.startDate).diff(moment.now(), 'days') || 1;
        }
      }
    });

    this.buttons$ = this.applicationService.getHomeButtons();
  }

  ngOnInit(): void {
    this.initDate();
  }

  public openLanguagesSelector(): void {
    const languageIndex = this.languages.findIndex((l) => l === this.language.get());
    this.languageModal.modalFooter = false;
    this.languageModal.modalHeader = false;
    this.languageModal.modalMessage = false;
    this.languageModal.open(SelectorComponent, {
      values: this.languages,
      selectedIndex: languageIndex
    });
  }

  public openVersionPopup(): void {
    this.applicationService.getNewApplicationVersion().subscribe((res: any) => {
      if (res?.appVersion) {
        this.versionModal.hasClassModal = true;
        this.versionModal.open(NewVersionModalComponent, {
          appVersion: res.appVersion
        });
      }
    });
  }

  public selectLanguagesMenu(item: any) {
    this.language.set(item.value.toLowerCase());
    this.currentLanguage = item.value.toLowerCase();
  }

  public openAppSelector(): void {
    const appIndex = this.applicationTypes.findIndex((t) => t.Value === this.currentAppType);
    this.appModal.modalFooter = false;
    this.appModal.modalHeader = false;
    this.appModal.modalMessage = false;
    this.currentPersonApplicationTypes = this.applicationTypes.filter((t) => this.currentPerson.applicationTypes.includes(t.Value));
    this.appModal.open(SelectorComponent, {
      values: this.currentPersonApplicationTypes
        .map((t) => t.Label),
      selectedIndex: appIndex
    });
  }

  public selectAppMenu(item: any) {
    const selectedApplicationType = this.currentPersonApplicationTypes[item.selectedIndex].Value;
    if (selectedApplicationType !== this.currentAppType) {
      this.applicationService.setApplicationType(selectedApplicationType).subscribe((type) => {
        window.location.reload();
      });
    }
  }

  public openInspections() {
    if (this.offlineInspection && this.offlineInspection.updatedOffline) {
      this.inspectionOfflineReminder.warningIcon = true;
      this.inspectionOfflineReminder.open();
    } else {
      this.goToInspections();
    }
  }

  public goToInspections() {
    this.router.navigate(['/inspectionbrowser/inspections']);
  }

  public newInspection() {
    if (this.isConnection) {
      this.router.navigate(['/inspectionbrowser/inspections/selectMachine']);
    }
  }

  openInspection(id: string) {
    if (this.isConnection) {
      this.router.navigate([`/inspectionbrowser/inspections/${id}`]);
    }
  }

  openUpcomingInspections() {
    if (this.isConnection) {
      this.inspectionService.filter = { from: new Date() };
      this.router.navigate([`/inspectionbrowser/inspections`]);
    }
  }

  openInspectionsInProgress() {
    if (this.isConnection) {
      this.inspectionService.filter = { status: 200 };
      this.router.navigate([`/inspectionbrowser/inspections`]);
    }
  }

  openLink(link: string) {
    window.open(link, '_blank');
  }

  get isOptimization() {
    return this.currentAppType === ApplicationType.Optimization;
  }
  get isInstallation() {
    return this.currentAppType === ApplicationType.Installation;
  }

  get inspectionsLabel() {
    return `home.inspection-${this.currentAppType}-list`;
  }

  get newInspectionLabel() {
    return `home.new-${this.currentAppType}-inspection`;
  }

  infix() {
    return this.isInstallation ? '-2' : '';
  }

  get dashboardTitleLabel() {
    return `home.inspection${this.infix()}`;
  }
  get inProgressLabel() {
    return `home.inspections${this.infix()}-in-progress`;
  }
  get noInProgressLabel() {
    return `home.no-inspections${this.infix()}-in-progress`;
  }
  get inspectionsStatisticLabel() {
    return `home.inspections${this.infix()}-statistic`;
  }
  get upcomingInspectionsLabel() {
    return `home.upcoming${this.infix()}-inspections`;
  }
  get noUpcomingInspectionsLabel() {
    return `home.no-upcoming${this.infix()}-inspections`;
  }
}
